module.exports = __webpack_public_path__ + "static/viewers-9e966c9fe15aec522d81083896e09d11.jpg";